import React, { useState } from 'react'
import SupplyBillAgreeIco from '../../../supplyBill/view/items/SupplyBillAgreeIco'
import MyModal from '../../../../UI/modal/MyModal'
import CommentIcon from '@mui/icons-material/Comment';
import ShieldIcon from '@mui/icons-material/Shield';
import AgreeSecurityForm from './AgreeSecurityForm';

const AgreeSecurityButton = ({ supplier }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <div>
            <SupplyBillAgreeIco
                classNameMain={'approval'}
                onClick={e => setOpen(true)}
                text={'Погодження службою безпеки'}
                ico={<ShieldIcon />}
                value={supplier.isAgreeSecurity}
            />

            {
                !supplier.isAgreeSecurity && supplier.isAgreeSecurity === false && supplier.disagreeSecurityText ?
                    <div className='approvalComment'>
                        <CommentIcon />
                        <p>
                            {supplier.disagreeSecurityText}
                        </p>
                    </div>
                : ''
            }
        </div>
        

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Погодження службою безпеки'}
            disableClickOutside={true}
            content={
                <AgreeSecurityForm
                    supplierBd={supplier}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeSecurityButton